import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import DatePicker from "react-datepicker";
import { GlobalContext } from "../../../../Contexts/GlobalContextProvider";
import iconcontentcalendar from "../../../../Images/Icons/iconcontentcalendar.png";

const DateFromInput = ({ search, setSearch }) => {
  const { t: translator } = useTranslation();
  const { selectedLanguageId } = useContext(GlobalContext);

  return (
    <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
      <label>{translator("InitialState-DateFrom")}</label>
      <div className="input-group">
        <div className="input-group-prepend">
          <span className="input-group-text" id="basic-addon1">
            <img src={iconcontentcalendar} alt="calendar" />
          </span>
        </div>
        <DatePicker
          autoComplete="off"
          showYearDropdown={true}
          className="form-control datepicker"
          dateFormat="dd.MM.yyyy"
          locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
          onChange={(date) => setSearch({ ...search, dateFrom: date })}
          selected={search.dateFrom}
          maxDate={search.dateTo !== null ? new Date(search.dateTo) : ""}
        />
      </div>
    </div>
  );
};

export default DateFromInput;
